import { create } from "zustand";

type TopUpState = {
  autoTopUpId: string | null;
  setAutoTopUpId: (id: string | null) => void;
  selectedCardId: string | null;
  setSelectedCardId: (id: string | null) => void;
};

export const useTopUpStore = create<TopUpState>((set) => ({
  autoTopUpId: null,
  setAutoTopUpId: (id) => set({ autoTopUpId: id }),
  selectedCardId: null,
  setSelectedCardId: (id) => set({ selectedCardId: id }),
}));
